import { SBaseDisplay } from '@summit/core';

import { EboObjectTO } from '../base-classes/ebo-object-to';
import { MaintEvent } from './maint-event';
import { MaintItem } from './maint-item';

export class MaintEventItem extends EboObjectTO implements SBaseDisplay {
  maintEventID: string;
  maintEvent: MaintEvent;
  maintItemID: string;
  maintItem: MaintItem;
  includeInMMR?: boolean;
  amount: number;
  comment: string;

  constructor(jsonData?: Partial<MaintEventItem>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.maintEvent) this.maintEvent = new MaintEvent(jsonData.maintEvent);
      if (jsonData.maintItem) this.maintItem = new MaintItem(jsonData.maintItem);
    }
    if (this.includeInMMR === undefined) this.includeInMMR = null;
  }

  toShortString(): string {
    if (this.maintItem && this.comment) return `${this.maintItem.name} - ${this.comment}`;
    return this.maintItem?.name ?? this.comment;
  }

  toMMRString(): string {
    if (this.maintItem && this.comment) return `${this.maintItem.mmrDisplayString} - ${this.comment}`;
    return this.maintItem?.mmrDisplayString ?? this.comment;
  }
}
